import type { OrganizationMemberPreview, OrganizationNode, OrganizationWorkerOption } from './model';

export const fixtureOrganizations: OrganizationNode[] = [
  { id: 'root', name: '한결', subtitle: '대표이사 CEO · 지주회사', manager: '정성진', managerId: '01', count: 1, location: '서울 본사' },
  { id: 'product', parentId: 'root', name: 'Product Division', subtitle: '제품 부문', manager: '윤서연', count: 36, location: '서울 본사' },
  { id: 'engineering', parentId: 'root', name: 'Engineering Division', subtitle: '엔지니어링 부문', manager: '우디(박진우)', managerId: '02', count: 12, location: '서울 본사' },
  { id: 'platform', parentId: 'engineering', name: 'Platform Engineering Team', subtitle: '플랫폼 엔지니어링 팀', manager: '이도현', count: 16, location: '서울 본사' },
  { id: 'backend', parentId: 'engineering', name: 'Backend Engineering Team', subtitle: '백엔드 엔지니어링 팀', manager: '김하늘', count: 14, location: '경북 지점' },
  { id: 'business', parentId: 'root', name: 'Business Division', subtitle: '비즈니스 부문', manager: '김서영', count: 61, location: '제주 지점' },
  { id: 'people', parentId: 'root', name: 'People & Culture', subtitle: '인사문화실', manager: '이정연', count: 38, location: '서울 본사' },
];

export const fixtureOrganizationWorkers: OrganizationWorkerOption[] = [
  { id: '01', name: '정성진', workerNumber: 'A0001' },
  { id: '02', name: '우디(박진우)', workerNumber: 'A0104' },
  { id: '03', name: '김민서', workerNumber: 'A0142' },
  { id: '04', name: '이수연', workerNumber: 'A0188' },
  { id: '05', name: '한도윤', workerNumber: 'A0203' },
  { id: '06', name: '강예린', workerNumber: 'A0221' },
  { id: '07', name: '장우진', workerNumber: 'A0238' },
];

const fixturePrimaryOrganizations: Record<string, string> = { '01': 'root', '02': 'engineering', '03': 'product', '05': 'business', '06': 'people', '07': 'platform' };
export function fixtureOrganizationMemberPreview(organizationId: string): OrganizationMemberPreview {
  const members = fixtureOrganizationWorkers.filter(worker => fixturePrimaryOrganizations[worker.id] === organizationId).slice(0, 4).map(({ id, name }) => ({ id, name }));
  return { members, total: fixtureOrganizations.find(organization => organization.id === organizationId)?.count ?? 0 };
}
